/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Open_Manager_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Open Style Guide Manager" |
*
* @param {Style_Guide_Open_Manager_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_open_manager_aria_label = /** @type {((inputs?: Style_Guide_Open_Manager_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Open_Manager_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le gestionnaire de guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Open Style Guide Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Open Style Guide Manager")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер открытых руководств по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrador de guías de estilo abierto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开放式样式指南管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドマネージャーを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओपन स्टाइल गाइड मैनेजर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciador de Guia de Estilo Aberto")
	return /** @type {LocalizedString} */ ("Open Style Guide Manager")
});